import { z } from "zod"

export const UpdateEmailSchema = z
  .object({
    currentEmail: z.email({
      error: "Current email is required",
    }),
    currentPassword: z.string().min(1, {
      error: "Current password is required!",
    }),
    email: z.email({
      error: "Email is required",
    }),
    confirmEmail: z.email({
      error: "Confirm email is required!",
    }),
  })
  .refine((data) => data.email === data.confirmEmail, {
    path: ["confirmEmail"],
    error: "notMatch",
  })

export type UpdateEmailForm = z.infer<typeof UpdateEmailSchema>

export const UpdatePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, {
      error: "Current password is required!",
    }),
    password: z.string().min(1, {
      error: "Password is required!",
    }),
    confirmPassword: z.string().min(1, {
      error: "Confirm password is required!",
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    error: "notMatch",
  })

export type UpdatePasswordForm = z.infer<typeof UpdatePasswordSchema>

export const UpdateCompanySchema = z.object({
  companyName: z.string().min(1, {
    error: "Company name is required",
  }),
  companyName2: z.string(),
  industry: z.string(),
  taxationID: z.string(),
  invoiceEmail: z.union([z.literal(""), z.email()]),
})

export type UpdateCompanyForm = z.infer<typeof UpdateCompanySchema>

export const UpdatePersonalSchema = z.object({
  title: z.string().min(1, {
    error: "Title is required",
  }),
  honorific: z.string(),
  firstName: z.string().min(1, {
    error: "First name is required",
  }),
  lastName: z.string().min(1, {
    error: "Last name is required",
  }),
  department: z.string(),
  phoneBusiness: z.string(),
  fax: z.string(),
  birthday: z.string(),
  preferredLanguage: z.string().min(1, {
    error: "Preferred language is required",
  }),
})

export type UpdatePersonalForm = z.infer<typeof UpdatePersonalSchema>
